'use strict';

angular
  .module('cfn')
  .factory('cfnBookingSupplyService', cfnBookingSupplyService);

cfnBookingSupplyService.$inject = [
  '$http',
  '$q',
  '$rootScope',
  '$timeout',
  'translateFilter',
  'bookingMaskService'
];
function cfnBookingSupplyService(
  $http,
  $q,
  $rootScope,
  $timeout,
  translateFilter,
  bookingMaskService
) {
  // helper function for getting the cropPrincipalId code
  // from the active crop model
  function getCropPrincipalId(parentScope, model, selectedCulture) {
    if (bookingMaskService.checkIfIndicationsAllowed(parentScope, model, false, selectedCulture)) {
      let activeCrop = bookingMaskService.getActiveCrop();

      if (activeCrop && activeCrop.cropPrincipalId) {
        return activeCrop.cropPrincipalId;
      }
    }
    return false;
  }

  function getEppoCode(parentScope, model, selectedCulture) {
    // helper function for getting the eppoCode
    // from the active crop model
    let eppoCode = false;
    if (bookingMaskService.checkIfIndicationsAllowed(parentScope, model, false, selectedCulture)) {
      let activeCrop = bookingMaskService.getActiveCrop();

      if (activeCrop && activeCrop.cropPrincipalId) {
        return activeCrop.cropPrincipalId;
      }
    }
    return false;
  }

  function compareUnits(item, homologaItem) {
    // use this function to compare the unit which is given from the backend
    // with the unit from the homologa service
    if (item.unit && homologaItem.unit) {
      if (item.unit === 'LIQUID_ML' && homologaItem.unit === 'ml/ha') {
        return true;
      } else if (item.unit === 'LIQUID_L' && homologaItem.unit === 'l/ha') {
        return true;
      } else if (item.unit === 'MASS_G' && homologaItem.unit === 'g/ha') {
        return true;
      } else if (item.unit === 'MASS_KG' && homologaItem.unit === 'kg/ha') {
        return true;
      }
    }
    return false;
  }

  function mergeObjects(obj1, obj2) {
    // merge the existing indication data with the max dose response
    Object.assign(obj1, obj2);
    let mergeObjects = [obj1, obj2];
    return mergeObjects.reduce((r, o) => {
      Object.keys(o).forEach(k => {
        r[k] = o[k];
      });
      return r;
    }, {});
  }

  // Public
  return {
    getCropPrincipalId: getCropPrincipalId,
    getEppoCode: getEppoCode,
    compareUnits: compareUnits,
    mergeObjects: mergeObjects
  };
}

export default cfnBookingSupplyService;
